// extracted by mini-css-extract-plugin
export default {"About":"about_About__zxvWZ"};